import * as events from './events'
import * as actions from './actions'

export const storeEvents: Record<string, any> = {
  [(events.PAYMENT_METHODS_LOAD, events.FINANCE_CALC_LOAD)]: actions.paymentMethodsLoadEvent,
}
